var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_116915",
    "data-name": "Group 116915",
    transform: "translate(-1203.923 -222.601)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_22590",
    "data-name": "Rectangle 22590",
    transform: "translate(1203.923 222.601)",
    fill: "#dfdf23",
    stroke: "#dfdf23",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 20,
    rx: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-download",
    "data-name": "Icon feather-download",
    transform: "translate(1208.922 227.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_365968",
    "data-name": "Path 365968",
    d: "M16.042,22.5v2.565a1.282,1.282,0,0,1-1.282,1.282H5.782A1.282,1.282,0,0,1,4.5,25.065V22.5",
    transform: "translate(-4.5 -14.805)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365969",
    "data-name": "Path 365969",
    d: "M10.5,15l3.206,3.206L16.912,15",
    transform: "translate(-7.935 -10.511)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365970",
    "data-name": "Path 365970",
    d: "M18,12.195V4.5",
    transform: "translate(-12.229 -4.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.85b605c6fce8980c9ba39ae5b5e20f72.svg";
export { ForwardRef as ReactComponent };